<template>
  <div>
    <select name="days" id="days" v-model="selectedDay" v-if="daysList.size > 0">
      <option :value="day" v-for="day in daysList" :key="day"> {{ day }} </option>
    </select>
    <div v-else class="text-lg pt-10">
      Non ci sono prossime lezioni al momento.
    </div>

    <section class="pt-10">
      <div
        v-for="lesson in filteredLessons"
        :key="lesson.id"
        class="w-3/4 mx-auto text-lg py-5 flex items-center justify-between">
          <div>
            {{ lesson.lesson_id }}
          </div>
          <div class="flex flex-col">
            <span>Teacher: {{ lesson.teacher.name }}</span>
            <span>Student: {{ lesson.student.name }} </span>
          </div>
          <div class="flex items-center">
            {{ getLessonStartHour(lesson) }}
            <span class="px-1"> - </span>
            {{ getLessonEndHour(lesson) }}
          </div>
          <button @click="joinLessonMeeting(lesson)">
            Join Lesson Meeting
          </button>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import DatesConversion from '@/mixins/DatesConversion';

export default {

  data() {
    return {
      lessons: [],

      selectedDay: dayjs.tz().format('DD/MM/YYYY'),
    };
  },

  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
    }),

    daysList() {
      return new Set(this.lessons.map(
        (lesson) => dayjs.tz(lesson.slot.start_date, this.choosenTimezone).format('DD/MM/YYYY'),
      ));
    },

    filteredLessons() {
      return this.lessons.filter(
        (lesson) => dayjs.tz(lesson.slot.start_date, this.choosenTimezone).format('DD/MM/YYYY') === this.selectedDay,
      );
    },
  },

  created() {
    this.getLessonsList();
  },

  mixins: [DatesConversion],

  methods: {
    getLessonsList() {
      axios.get('/api/lessons').then(({ data }) => {
        this.lessons = data;
      });
    },

    getLessonStartHour(lesson) {
      return this.convertDateInChoosenTimezone(lesson.slot.start_date).format('HH:mm');
    },

    getLessonEndHour(lesson) {
      return this.convertDateInChoosenTimezone(lesson.slot.end_date).format('HH:mm');
    },

    joinLessonMeeting(lesson) {
      axios.get(`/api/lesson/${lesson.booking_id}/get-url?for=admin`).then(({ data }) => {
        window.location.href = data;
      }).catch(() => {
        this.createNotification('error', 'Non riusciamo a collegarti al meeting. Ritenta tra qualche minuto');
      });
    },
  },

};
</script>
